/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

var jquery = null;

if (window.jQuery) {
  jquery = window.jQuery;
} else if (window.Checkout && window.Checkout.$) {
  jquery = window.Checkout.$;
}

function check_minicart(event,elem){
  event.preventDefault();
  if(!$("#condiciones_desktop").is(":checked")){
    $("#condiciones_desktop").parent().addClass("error");
  }else{
    $("#"+$(elem).attr("form")).submit()
  }
}

jquery(document).ready(function(){
  var $ = jquery;

  // Aqui vivia un automatismo que anadia una pua de regalo al carrito cuando
  // detectaba un producto con el tag rocktud. Se retira porque el producto de
  // esa pua estaba en borrador, asi que cada compra lanzaba una peticion que
  // Shopify rechazaba con un 422. Fallaba en silencio y solo generaba ruido.
  //
  // El regalo que si se usa es la bolsa, y ya no esta escrita a mano: se elige
  // desde el personalizador, en los ajustes de la seccion mini-cart.


    function updateGift(){
  	  	
    //if(theme.settings.enable_auto){
      //$(".gift_btn").attr("data-vid",theme.autoProduct);
      //$(".gift_text").text(theme.giftText);

      $.getJSON('/cart.js', function(cart){
        var variantIds = [];
        var vid = $(".gift_btn").data("vid");
        var items = cart.items;
        $.each(items, function(index, item) {
          variantIds.push(items[index].id);
        });
        if ($.inArray(vid, variantIds) >= 0) {
          $(".gift_wrap").addClass("hide");
        }else{
          $(".gift_wrap").each(function(){ $(this).addClass('testclass').removeClass("hide");});
        }
      })
  }
  
  
    updateGift();
  // Antes esto era un setInterval de 1 segundo: consultaba /cart.js 60 veces
  // por minuto en cada pestana abierta, malgastaba peticiones y llegaba a
  // provocar bloqueos por exceso de trafico de Shopify. Se reacciona a los
  // eventos del carrito, que es cuando el estado puede haber cambiado.
  ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function(ev){
    document.addEventListener(ev, updateGift);
    document.documentElement.addEventListener(ev, updateGift);
  });

  $(document).on('click','.gift_btn',function(e) {  
     console.log("clicked add");
  	var vid = $(this).data("vid")
    $.post('/cart/update.js', "updates["+vid+"]=1")
    .done(function( data ) { 
      //window.location.href = "/cart";
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    });
  })
  
  if($('.product-tabs').length>0){

    $('.tab-content-0').addClass('current');
    $('.tab-link-0').addClass('current');

    $('ul.tabs > li').on('click keyup', function(e) {
      if ( e.type === 'keyup' && e.keyCode !== 13 ) return;

      var tab_id = $(this).attr('data-tab');

      $('ul.tabs > li').removeClass('current');
      $('.tab-content').removeClass('current');

      $(this).addClass('current');
      $('.tab-content-' + tab_id).addClass('current');
    });
    
    // mobile accordion for tabs content
    $('.accordion-toggle').click(function() {
      if($(this).next('div').is(':visible')){
        $(this).next('div').slideUp('fast');
      } else {
        $(this).next('div').slideDown('fast');
      }
      $(this).find('.accordion__icon').toggleClass('rotate-90');
    });
  }
/*
//NO FUNCIONA
  var menu = $('.pagination__nav'), pos = menu.offset();
  $(parent.window.document).scroll(function(){
    var scrollPosition = $(window).height() + $(window).scrollTop();
    console.log(pos.top,scrollPosition);
    if(scrollPosition >= pos.top){
      $(".pagination__nav-item[rel=next]").click();
    }
  });
*/
});

function buscar_pedido(){
  //console.log("HOLA!");
  var sigo = true;
  var $ = jQuery;
  
  if($("#n_pedido").val().length<7 || $("#email").val()==""){
    sigo = false;
    alert("Debes introducir el número de pedido y la dirección de email");
  }
  if(sigo){
    $('<p class="cargando text-center"><small>Buscando información del pedido, por favor, espera unos instantes...</small></p>').insertBefore($("#tabla_devoluciones"));
    $("#formulario_devolucion table tbody").empty();
    $.post("https://intranet.rocktud.com/info_pedido_dev.php",$("#info_pedido").serialize(),function(data){
      //console.log(data);
      jQuery('#tabla_devoluciones').removeClass('hidden');
      jQuery('p.cargando').remove();
      
      $("#fecha_pedido").html(data.fecha_pedido);
      $("#fecha_envio").html((data.fecha_envio!="" ? data.fecha_envio : '--'));
      $("#fecha_max_devolucion").html((data.max_devoluciones!="" ? data.max_devoluciones : '14 días desde que lo recibas'));
      $("#id_cliente").val(data.id_cliente);
      $("#id_pedido").val(data.id_pedido);
      //$("#fecha_max_cambios").html(data.max_cambios);
      
      //console.log(data.lineas);
      for(i in data.lineas){
        //console.log(i);
        var tmp = data.lineas[i];
        var lin = '';
        lin += '<tr id="'+tmp.id+'">';
        lin += '          <td data-label="Producto">';
        lin += '            <a href="'+tmp.url+'" title=\''+tmp.title+'\'>'+tmp.title+'</a>';
        lin += '            </td>';
        //lin += '            <td data-label="SKU">'+tmp.sku+'</td>';
        lin += '          <td>';
        lin += '            <input type="hidden" name="productos[]" value="'+tmp.product_id+'">';
        lin += '            <input type="hidden" name="variantes[]" value="'+tmp.variant_id+'">';
        lin += '            <div class="input">';
        lin += '                <div class="select-wrapper is-filled">';
        lin += '                  <select class="select" name="tipo_cambio[]" id="tipo_cambio_"><option value="" selected="selected">No</option><option value="devolucion">Devolver</option></select>';
        lin += '                  <svg focusable="false" width="12" height="8" class="icon icon--chevron   " viewBox="0 0 12 8">';
        lin += '                    <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>';
        lin += '                  </svg>';
        lin += '                </div>';
        lin += '              </div>';
        
        //lin += '            <select name="tipo_cambio[]">';
        //lin += '              <option value="" selected="selected">No</option>';
        //if(data.devoluciones==true){
        //  lin += '              <option value="devolucion">Devolver</option>';
        //}
        //if(data.cambios==true){
        //  for(j in tmp.variants){
        //    if(tmp.variants[j].id!=tmp.variant_id){
        //      lin += '              <option value="'+tmp.variants[j].id+'|'+tmp.variants[j].title+'">';
        //      lin += '              Cambiar por: '+tmp.variants[j].title;
        //      lin += '              </option> ';
        //    }
        //  }
        //}
        //lin += '			</select>';
        lin += '          </td>';
        lin += '            <td data-label="Cantidad">';
        lin += '                    <div class="input">';
        lin += '                      <input type="number" name="cantidad[]" value="'+tmp.quantity+'" min="1" max="'+tmp.quantity+'" class="input__field input__field--text is-filled">';
        lin += '                   </div>';
        lin += '          </td>';
        //lin += '            <td data-label="Cantidad"><input type="number" name="cantidad[]" value="'+tmp.quantity+'" min="1" max="'+tmp.quantity+'"></td>';
        lin += '          </tr>';
        $(lin).appendTo($("#formulario_devolucion table tbody"));
      }
    },"json");
  }
}
function solicitar_devolucion(){
 var sigo = false;
  var $ = jQuery;
  $.each($("#formulario_devolucion tr"),function(key,value){
    if($(this).find("select[name^=tipo_cambio]").val()!="" && $(this).find("input[name^=cantidad]").val()>0){
      sigo = true;
    }
  });
  if(!sigo){
    alert("Debes seleccionar al menos un artículo a devolver");
  }
  else if(!$("#formulario_devolucion input[name=condiciones]").is(":checked")){
    alert("Debes aceptar los términos y condiciones de uso");
  }
  else{
    if(confirm("¿Solicitar devolución?")){
      //ENVIO SOLICITUD
      $.post("https://intranet.rocktud.com/solicitar_devolucion.php",$("#formulario_devolucion").serialize(),function(data){
          alert("Solicitud de devolución cursada correctamente. En breve recibirás en tu correo electrónico las instrucciones a seguir. Comprueba también la bandeja de Correo No Deseado");
          //window.location.href="https://thefandation.theimagos.com/account";
      });
    }
  }
}
function check_devoluciones(id){
  var $ = jQuery;
  $.post("https://intranet.rocktud.com/estado_devoluciones.php",{id_pedido:id},function(data){
    if(typeof(data.estado)!="undefined"){
     $("#estado_devolucion #fecha_solicitud").html(data.fecha_solicitud);
     $("#estado_devolucion #estado_devolucion").html(data.estado);
     $("#estado_devolucion").show();
    }
  },"json");
}